import { MouseEventHandler, useState } from 'react';
import { useIntl } from 'react-intl';
import Divider from '@mui/material/Divider';

import AgTypography from '../../../Styles/AgTypography';
import { AgColor } from '../../../Styles/AgColor';

export interface AgAccountProfileCardProps {
  width?: string;
  userType?: number;
  img?: string;
  name?: string;
  accountID?: string;
  village?: string;
  email?: string;
  phone?: string;
  inactive?: boolean;
  isSelected?: boolean;
  onClick?: MouseEventHandler;
  cardTitle?: string;
  idLabel?: string;
  hideInfo?: boolean;
}

const AgAccountProfileCard = (
  {
    width,
    userType,
    img,
    name,
    accountID,
    village,
    email,
    phone,
    inactive,
    isSelected,
    onClick,
    cardTitle,
    idLabel,
    hideInfo
  }: AgAccountProfileCardProps
) => {
  const messages = useIntl().formatMessage;
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };
  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  let profileUserType = '';
  switch (userType) {
    case 2:
      profileUserType = messages({ id: 'USER_TYPE_DEMO' });
      break;
    case 1:
      profileUserType = messages({ id: 'USER_TYPE_AGUNITY' });
      break;
  }

  return (
    <AgTypography
      style={{
        width: width ?? '216px',
        padding: '8px 12px 12px 12px',
        boxSizing: 'border-box',
        display: 'grid',
        gap: '16px',
        borderRadius: '8px',
        cursor: 'pointer',
        outline:
          isHovered || isSelected
            ? `2px solid ${AgColor.secondaryDark}`
            : `1px solid ${AgColor.grey3}`,
        boxShadow: '0px 1px 2px 0px #0000000D',
        backgroundColor: AgColor.grey0,
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={onClick}
    >
      <AgTypography
        style={{
          display: 'grid',
          gap: '8px'
        }}
      >
        <AgTypography
          style={{
            display: 'flex',
            justifyContent: 'space-between'
          }}
        >
          <AgTypography
            contentStyle={'AP.H5.Bold'}
            style={{
              color: inactive
                ? AgColor.errorMain
                : (isHovered || isSelected)
                  ? AgColor.secondaryDark
                  : AgColor.grey6
            }}
          >
            {cardTitle ?? messages({ id: 'PROFILE_PERSONAL_ACCOUNT' })}
            {inactive && (' - ' + messages({ id: 'MEMBER_PERSONAL_DETAILS_INACTIVE' }))}
          </AgTypography>
          <AgTypography
            message={profileUserType}
            contentStyle={'AP.H5.Bold'}
            style={{
              color: AgColor.primaryLight
            }}
          />
        </AgTypography>
        <AgTypography
          style={{
            display: 'flex',
            gap: '12px',
            justifyContent: 'start',
            alignItems: 'center'
          }}
        >
          <img
            src={img}
            alt='Avatar'
            style={{ width: '48px', height: '48px', borderRadius: '8px', objectFit: 'cover' }}
          />
          <AgTypography contentStyle={'AP.H3.Medium'} message={name} style={{ width: '132px', overflow: 'hidden' }}/>
        </AgTypography>
      </AgTypography>

      <AgTypography
        style={{
          display: 'grid',
          gap: '8px',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
        }}
      >
        <AgTypography
          style={{
            display: 'flex',
            justifyContent: 'space-between'
          }}
        >
          <AgTypography
            message={idLabel ?? messages({ id: 'PROFILE_ACCOUNT_ID' })}
            contentStyle={'AP.H5.Bold'}
            style={{
              color: AgColor.grey6
            }}
          />
          <AgTypography
            message={accountID}
            contentStyle={'AP.H5.Bold'}
            style={{
              color: AgColor.grey9
            }}
          />
        </AgTypography>

        {hideInfo ? null : (
          <>
            <Divider sx={{ margin: '4px 0', color: AgColor.grey4 }} />

            <AgTypography
              style={{
                display: 'flex',
                justifyContent: 'space-between'
              }}
            >
              <AgTypography
                message={messages({ id: 'PROFILE_VILLAGE' })}
                contentStyle={'AP.H5.Bold'}
                style={{
                  color: AgColor.grey6
                }}
              />
              <AgTypography
                message={village}
                contentStyle={'AP.H5.Bold'}
                style={{
                  color: AgColor.grey9,
                  width: '130px',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}
              />
            </AgTypography>
            <AgTypography
              style={{
                display: 'flex',
                justifyContent: 'space-between'
              }}
            >
              <AgTypography
                message={messages({ id: 'PROFILE_EMAIL' })}
                contentStyle={'AP.H5.Bold'}
                style={{
                  color: AgColor.grey6
                }}
              />
              <AgTypography
                message={email}
                contentStyle={'AP.H5.Bold'}
                style={{
                  color: AgColor.grey9,
                  width: '130px',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}
              />
            </AgTypography>
            <AgTypography
              style={{
                display: 'flex',
                justifyContent: 'space-between'
              }}
            >
              <AgTypography
                message={messages({ id: 'PROFILE_PHONE' })}
                contentStyle={'AP.H5.Bold'}
                style={{
                  color: AgColor.grey6
                }}
              />
              <AgTypography
                message={phone}
                contentStyle={'AP.H5.Bold'}
                style={{
                  color: AgColor.grey9,
                  width: '130px',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis'
                }}
              />
            </AgTypography>
          </>
        )}
      </AgTypography>
    </AgTypography>
  );
};

export default AgAccountProfileCard;